import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow_right",
  "use": "arrow_right-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"arrow_right\">\n  <defs>\n    <style>\n      #arrow_right .cls-1 {\n        fill: #d9d9d9;\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path id=\"arrow_right_向右箭头\" class=\"cls-1\" d=\"M3058,933.307l2.4-2.307,11.22,10.781v0l2.38,2.283-0.01.006,0.01,0-2.4,2.306v0L3060.54,957l-2.38-2.284,11.06-10.628Zm0,0\" transform=\"translate(-3046 -924)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow_right.svg
// module id = uvSz
// module chunks = 37